import { Component, HostBinding, Input, ChangeDetectionStrategy, ViewEncapsulation, forwardRef, ContentChildren, QueryList,
    AfterContentInit, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { coerceBooleanProperty } from '@angular/cdk/coercion';

import { BaseDirective } from '../../base.directive';
import { EuiIconComponent } from '../atoms';

// tslint:disable max-line-length
@Component({
    templateUrl: './eui-chip.component.html',
    selector: 'eui-chip, span[euiChip], li[euiChip]',
    styleUrls: ['./styles/_index.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class EuiChipComponent extends BaseDirective implements AfterContentInit, AfterViewInit {

    @Input() euiInternalId: string = null;
    @Input() tooltipMessage: string;
    @Input() data: any;

    @Input()
    get isChipRemovable() { return this._isChipRemovable; }
    set isChipRemovable(value) { this._isChipRemovable = coerceBooleanProperty(value); }
    _isChipRemovable = false;

    @Input()
    get hasTooltip() { return this._hasTooltip; }
    set hasTooltip(value) { this._hasTooltip = coerceBooleanProperty(value); }
    _hasTooltip = false;

    @Output() remove = new EventEmitter<EuiChipComponent>();

    public iconAfter = false;
    public iconBefore = false;

    @HostBinding('class')
    get cssClasses() {
        return [
            super.getCssClasses('eui-chip'),
            this.isChipRemovable ? `eui-chip--removable` : ``,
            this.iconAfter && !this.iconBefore ? `eui-chip--icon-after` : ``,
            this.iconBefore && !this.iconAfter ? `eui-chip--icon-before` : ``,
            this.iconBefore && this.iconAfter ? `eui-chip--icon-both` : ``,
        ].join(' ').trim();
    }

    @HostBinding('attr.role') attr_Role = 'listbox';
    @HostBinding('attr.aria-label') attr_AriaLabel = 'Chip content';
    @ContentChildren(forwardRef(() => EuiIconComponent)) euiIcons: QueryList<EuiIconComponent>;
    @ViewChild('chipLabel') chipLabel: ElementRef<HTMLInputElement>;

    constructor(private cd: ChangeDetectorRef) {
        super();
    }

    ngAfterContentInit() {
        this.e2eAttr = 'eui-chip';
        // Apply primary to default only if no other type class is used
        if (!this.euiPrimary && !this.euiSecondary && !this.euiInfo && !this.euiSuccess && !this.euiWarning && !this.euiDanger && !this.euiAccent) {
            this.euiPrimary = true;
        }

        if (this.euiIcons) {
            this.euiIcons.forEach((icon, idx) => {
                icon.styleClass = 'eui-button__icon';
            });
        }
    }

    ngAfterViewInit() {
        setTimeout(() => {
            const children = this.chipLabel.nativeElement.children;
            if (children.length > 0) {
                this.iconAfter = children[children.length - 1].classList.contains('eui-icon');
                this.iconBefore = children[0].classList.contains('eui-icon');
            }
        });
    }

    public onRemove() {
        this.remove.emit(this.data);
    }
}
